import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Linkedin, ArrowUpRight } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/site-data";

export default function Footer() {
    return (
        <footer data-testid="main-footer" className="bg-[#101A2C] text-white grain-overlay">
            <div className="container-vl py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
                <div className="md:col-span-4">
                    <div className="mb-5">
                        <span className="font-display uppercase tracking-wider text-xl md:text-2xl font-semibold text-white">
                            Vibhuti Logistics
                        </span>
                        <span className="block text-[10px] tracking-[0.25em] uppercase text-[#F4A000] mt-1">
                            3PL · 4PL · Since 2004
                        </span>
                    </div>
                    <p className="text-sm text-[#CBD5E1] leading-relaxed mb-6 max-w-md">
                        Integrated 3PL & 4PL logistics solutions for manufacturing businesses across India. Customized supply-chain partnerships since 2004.
                    </p>
                    <div className="space-y-3 text-sm">
                        <div className="flex items-start gap-3" data-testid="footer-address">
                            <MapPin className="h-4 w-4 mt-0.5 text-[#F4A000]" strokeWidth={1.5} />
                            <span className="text-[#CBD5E1]">{COMPANY.address}</span>
                        </div>
                        {COMPANY.phones.map((p, idx) => (
                            <a
                                key={p}
                                href={`tel:${p.replace(/\s/g, "")}`}
                                className="flex items-center gap-3 text-[#CBD5E1] hover:text-white"
                                data-testid={`footer-phone-${idx}`}
                            >
                                <Phone className="h-4 w-4 text-[#F4A000]" strokeWidth={1.5} /> {p}
                            </a>
                        ))}
                        <a
                            href={`mailto:${COMPANY.email}`}
                            className="flex items-center gap-3 text-[#CBD5E1] hover:text-white"
                            data-testid="footer-email"
                        >
                            <Mail className="h-4 w-4 text-[#F4A000]" strokeWidth={1.5} /> {COMPANY.email}
                        </a>
                    </div>
                </div>

                <div className="md:col-span-3">
                    <h4 className="overline mb-5 text-[#F4A000]">Navigate</h4>
                    <ul className="space-y-2.5">
                        {NAV_LINKS.map((l) => (
                            <li key={l.href}>
                                <Link
                                    to={l.href}
                                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                                    className="text-sm text-[#CBD5E1] hover:text-white inline-flex items-center gap-1.5 group"
                                >
                                    {l.label}
                                    <ArrowUpRight className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <h4 className="overline mb-5 text-[#F4A000]">Services</h4>
                    <ul className="space-y-2.5">
                        {SERVICES.slice(0, 6).map((s) => (
                            <li key={s.slug}>
                                <Link
                                    to="/services"
                                    className="text-sm text-[#CBD5E1] hover:text-white"
                                    data-testid={`footer-service-${s.slug}`}
                                >
                                    {s.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-2">
                    <h4 className="overline mb-5 text-[#F4A000]">Connect</h4>
                    <div className="flex gap-3 mb-6">
                        <a
                            href={COMPANY.socials.linkedin}
                            aria-label="LinkedIn"
                            className="w-9 h-9 inline-flex items-center justify-center border border-[#4B6390] hover:border-[#F4A000] hover:bg-[#F4A000] hover:text-[#101A2C] transition-colors"
                            data-testid="footer-linkedin"
                        >
                            <Linkedin className="h-4 w-4" strokeWidth={1.5} />
                        </a>
                    </div>
                    <Link
                        to="/contact"
                        data-testid="footer-cta"
                        className="inline-block text-xs uppercase tracking-widest font-bold text-[#F4A000] border-b border-[#F4A000] pb-1"
                    >
                        Request Quote →
                    </Link>
                </div>
            </div>

            <div className="border-t border-[#28406A]">
                <div className="container-vl py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-[#4B6390]">
                    <span>© {new Date().getFullYear()} Vibhuti Logistics. All rights reserved.</span>
                    <span className="font-mono">CUSTOMIZED LOGISTICS SOLUTIONS SINCE 2004</span>
                </div>
            </div>
        </footer>
    );
}
